import { useCallback } from "react";

import { getReleaseImagesResourceQueryOptions } from "@/components/release-images-query";
import { orpc } from "@/utils/orpc.client";

import { useDeferredResourceQuery } from "./use-deferred-resource";

export function useReleaseImagesResource(releaseId: string, options?: { enabled?: boolean }) {
  const compute = useCallback(
    () => orpc.music.computeReleaseImagesResource.call({ id: releaseId }),
    [releaseId],
  );
  const result = useDeferredResourceQuery({
    queryOptions: getReleaseImagesResourceQueryOptions(releaseId, options),
    compute,
  });

  return {
    ...result,
    images: result.value ?? [],
  };
}
